<template>
    <Card :header="$t('filters')">

        <form @keyup.enter="fetchReporterInvoices()">

            <b-form-group :label="$t('advertiser')" label-cols-sm="3">
                <Multiselect
                    :initial-value="parentComponent.filters.advertisers"
                    show-selected
                    asynchronous
                    multiple
                    show-checkboxes
                    :clear-on-select="false"
                    :close-on-select="false"
                    :fetch-options-function="fetchAdvertisers"
                    :parse-options-function="parseAdvertisers"
                    :placeholder="$t('selectField.placeholder')"
                    track-by="id"
                    label="optionName"
                    select-label=""
                    :disabled="parentComponent.loading"
                    :track-by-label="$t('id')"
                    @changeTrackBy="parentComponent.filters.advertisers = $event"
                />
            </b-form-group>

            <b-form-group :label="$t('shop')" label-cols-sm="3">
                <MultiselectCampaigns
                    :initial-value="parentComponent.filters.campaigns"
                    :disabled="parentComponent.loading"
                    :placeholder="$t('campaign')"
                    @changeTrackBy="parentComponent.filters.campaigns = $event"
                />
            </b-form-group>

            <b-form-group :label="$t('transactions.dateRange')" label-cols-sm="3">
                <FormDatepicker
                    :value="[parentComponent.filters.startDate, parentComponent.filters.endDate]"
                    :placeholder="$t('all')"
                    :disabled="parentComponent.disabled"
                    :clearable="false"
                    mode="range"
                    @from="parentComponent.filters.startDate = $event"
                    @to="parentComponent.filters.endDate = $event"
                />
            </b-form-group>

            <b-form-group :label="$t('status')" label-cols-sm="3">
                <b-form-checkbox-group v-model="parentComponent.filters.statuses" :options="statusesOption" class="h-100 d-flex align-items-center" :disabled="parentComponent.loading" />
            </b-form-group>

            <div class="d-flex gap-3">
                <ButtonIcon :disabled="parentComponent.loading" @click="parentComponent.filterData()">
                    {{ $t('filter') }}
                </ButtonIcon>
                <ButtonIcon variant="light" :disabled="parentComponent.loading" @click="parentComponent.resetData()">
                    {{ $t('reset') }}
                </ButtonIcon>
            </div>

        </form>
    </Card>
</template>



<script>
    import Role from '@/Role';
    import userService from '@/services/userService';
    import Multiselect from '@/components/common/Multiselect.vue';
    import FormDatepicker from '@/components/common/FormDatepicker.vue';
    import MultiselectCampaigns from '@/components/common/MultiselectCampaigns.vue';

    export default {
        name: 'Filters',
        components: {
            Multiselect,
            FormDatepicker,
            MultiselectCampaigns,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {};
        },
        computed: {
            statusesOption() {
                return [
                    { text: this.$t('settled'), value: 3 },
                    { text: this.$t('notSettled'), value: 0 },
                ];
            },
            datePickerConfig() {
                return { mode: 'range' };
            },
        },
        methods: {
            fetchAdvertisers({ search }) {
                const requestParams = { search, roles: [Role.ADVERTISER] };
                return userService.getUsers({ requestParams });
            },
            parseAdvertisers(data) {
                return (data?.items || []).map(item => ({ ...item, optionName: `${item.profile.firstName} ${item.profile.lastName} (${item.username})` }));
            },
        },
    };
</script>
